export const getAppleWalletPassUrl = (guestExternalId: string) => (
  `${import.meta.env.VITE_API_BASE}/api/v3/public/guests/${guestExternalId}/apple_pass`
)

export const getGoogleWalletPassUrl = (guestExternalId: string) => (
  `${import.meta.env.VITE_API_BASE}/api/v3/public/guests/${guestExternalId}/google_pass`
)

const GOOGLE_WALLET_BADGE_BASE = "https://data.diobox.com/app/web/assets/email-dio/add-to-google-wallet"

// Google's official badges vary in width per language, so render at a fixed
// height and let the width follow — their brand rules forbid distorting them.
export const getGoogleWalletBadge = (language: string) => ({
  src: `${GOOGLE_WALLET_BADGE_BASE}/${language}.png`,
  srcSet: `${GOOGLE_WALLET_BADGE_BASE}/${language}.png 1x, ${GOOGLE_WALLET_BADGE_BASE}/${language}@2x.png 2x`,
})
